import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import InvitePeopleComponent, { formSelector } from '../../components/invite-people/index';
import { EMAIL_WITH_NAME_REGEXP } from '../../components/invite-people/validate';
import Alert, { formatContentWithEmoji } from '../../components/alert';
import { getCurrentPurchase } from '../../selectors/purchase-selector';
import { ALERT_INNER_MODAL } from '../../actions/ui';
import {
  invitePeople,
  hideInviteModal,
  showInviteConfirmationModal,
  showModalInnerAlert,
} from '../../actions/index';

class InvitePeople extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(props) {
    const { purchaseId, authentication } = this.props;

    const params = {
      subject: props.subject,
      message: props.message,
      invitees: formatInvitees(props.emails),
    };

    return this.props.actions.invitePeople(purchaseId, authentication, params)
      .then(() => {
        this.props.actions.hideInviteModal();
        this.props.actions.showInviteConfirmationModal();
      }).catch((error) => {
        if (!error.is422) {
          throw new SubmissionError({
            _error: error.message,
          });
        }

        const content = formatContentWithEmoji(error.message, '‼️');
        this.props.actions.showModalInnerAlert(content);
      });
  }

  hideContactsImportOptions() {
    setTimeout(() => {
      this.props.hideContactsImportOptions();
    }, 300);
  }

  showContactsImportOptions() {
    this.props.showContactsImportOptions();
  }

  renderInnerAlert() {
    const innerAlertConfig = this.props.alerts[ALERT_INNER_MODAL];
    if (!innerAlertConfig) return null;

    const { content, type } = innerAlertConfig;

    return (
      <Alert type={type} onClose={this.onInnerAlertClose}>
        {content}
      </Alert>
    );
  }

  render() {
    return (
      <InvitePeopleComponent
        emails={this.props.emails}
        onSubmit={this.onSubmit}
        merchant={this.props.merchant}
        purchaseName={this.props.purchaseName}
        innerAlert={this.renderInnerAlert()}
      />
    );
  }
}

const formatInvitees = (emails = []) => (
  emails
    .filter(email => EMAIL_WITH_NAME_REGEXP.test(email))
    .map(email => ({ email }))
);

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);

  return {
    alerts: state.ui.alerts,
    emails: formSelector(state, 'emails'),
    purchaseId: purchase.id,
    purchaseName: purchase.product.name,
    merchant: purchase.merchant,
    authentication: state.session.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    invitePeople,
    hideInviteModal,
    showInviteConfirmationModal,
    showModalInnerAlert,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitePeople);



// WEBPACK FOOTER //
// ./src/desktop/containers/invite-people/index.container.js